<template>
<div class="chapter">
<div class="inner_page">
<p class="ct">
					TABLE OF CONTENTS </p>
<p class="ctt" style="margin-top:3em;"><a href="#/preface" id="preface">
<b><i>Preface</i></b> </a></p>
<p class="ctt"><a href="#/chapter01" id="ch1">
<b><i>Chapter I :Moscow Exchange Year, 1961-62</i></b> </a></p>
<p class="ctt"><a href="#/chapter02" id="ch2">
<b><i>Chapter II : Wisconsin to St. Petersburg</i></b> </a></p>
<p class="ctt"><span href="#/chapter03" id="ch3" title="Link target outside of Sample">
<b><i>Chapter III : Moscow</i></b> </span></p>
<p class="ctt"><span href="#/chapter04" id="ch4" title="Link target outside of Sample">
<b><i>Chapter IV : Moscow to the Caucasus</i></b> </span></p>
<p class="ctt"><span href="#/chapter05" id="ch5" title="Link target outside of Sample">
<b><i>Chapter V : Georgia and Black Sea</i></b> </span></p>
<p class="ctt"><span href="#/chapter06" id="ch6" title="Link target outside of Sample">
<b><i>Chapter VI : Odessa, Kiev, and Over the Border</i></b> </span></p>
<p class="ctt"><span href="#/chapter07" id="ch7" title="Link target outside of Sample">
<b><i>Chapter VII : Stambul to Brussels, 1977</i></b> </span></p>
<p class="ctt"><span href="#/chapter08" id="ch8" title="Link target outside of Sample">
<b><i>Chapter VIII : By Volga to Kizhi, 1997</i></b> </span></p>
<p class="ctt"><span href="#/chapter09" id="ch9" title="Link target outside of Sample">
<b><i>Chapter VIII : The Red Goddess in Krasnodar, 1991</i></b> </span></p>
<p class="ctt"><span href="#/chapter10" id="ch10" title="Link target outside of Sample">
<b><i>Chapter IX : Queuing Up: The West in Krasnodar, 1991</i></b> </span></p>
<p class="ctt"><span href="#/chapter11" id="ch11" title="Link target outside of Sample">
<b><i>Chapter XI : Krasnodar Once More: 1997</i></b> </span></p>
<p class="ctt">
<b><i><span href="#/works_cited" id="AHxB" title="Link target outside of Sample">Works Cited</span></i></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e34c9766